export default __webpack_public_path__ + "static/media/concluido-icon.5b1a0bcc.svg";